export default {
      id: "speechmate-usage",
      viewBox: "0 0 100 12",
      url: "assets/" + "sprite.svg#speechmate-usage",
      toString: function () {
        return this.url;
      }
    }